import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAgents } from "@/components/Agents/AgentsContext";
import { agentsHref } from "@/lib/atwAgentsHost";

export function BillingPage() {
  const { org, may, viewOnly } = useAgents();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Billing</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Plan and add-ons for this Agent Organization. Payment provider wiring comes later.
        </p>
      </div>

      {viewOnly ? (
        <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100">
          Standard role is view only for billing.
        </p>
      ) : null}

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            Current plan
            <Badge>{org.planLabel}</Badge>
          </CardTitle>
          <CardDescription>
            Unlimited agents on every plan. Usage comes from the shared credit pool. Overseer is
            included.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p>Add-on: Max 20× credits ({org.maxAddon ? "on" : "off"}).</p>
          <p className="text-muted-foreground">
            Invoices, payment methods, and tax details will appear here once a provider is
            connected. Backend routes are not live yet (Stripe or Zoho Billing TBD).
          </p>
          <div className="flex flex-wrap gap-2">
            {may("manage_billing") ? (
              <Link to={agentsHref("/checkout")}>
                <Button type="button">Open Checkout</Button>
              </Link>
            ) : (
              <Button type="button" disabled>
                Open Checkout
              </Button>
            )}
            <Button type="button" variant="outline" disabled title="Blocked until billing API ships">
              Manage payment method
            </Button>
            <Button type="button" variant="outline" disabled title="Blocked until billing API ships">
              View invoices
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
